import { render, staticRenderFns } from "./ApprovalQueue.vue?vue&type=template&id=274108a5&scoped=true"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js"
import style0 from "./ApprovalQueue.vue?vue&type=style&index=0&id=274108a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274108a5",
  null
  
)

export default component.exports